import React from 'react'
import clsx from 'clsx'

import { Text } from '@wartek-id/text'
import { Button } from '@wartek-id/button'
import { Icon } from '@wartek-id/icon'
import { Badge } from '@wartek-id/badge'

import { Anchor } from 'components/Anchor'
import {
  CERTIFICATE_STATUS,
  type CertificateStatusType,
} from 'api/microlearning/types'

type CertificateAksiNyataCard = {
  certificateStatus?: CertificateStatusType
  topikId?: string | number
  variant?: 'default' | 'desktop'
  showHeader?: boolean
}

const CertificateAksiNyataCard = (props: CertificateAksiNyataCard) => {
  const isDesktop = props.variant === 'desktop'
  const showHeader = props.showHeader !== false
  const contentClassName = clsx(
    showHeader && 'mt-2',
    !isDesktop && 'border border-subdued rounded p-4 bg-white'
  )

  const renderContent = (
    certificateStatus?: CertificateAksiNyataCard['certificateStatus']
  ) => {
    if (
      !certificateStatus ||
      certificateStatus === CERTIFICATE_STATUS.NOT_AVAILABLE
    ) {
      return (
        <div className={clsx('flex flex-col gap-3', contentClassName)}>
          <Text variant="body-sm" color="subdued">
            Sertifikat sudah tidak tersedia karena tidak ada Aksi Nyata yang
            perlu dikerjakan. Anda cukup menggunakan{' '}
            <strong>Surat Keterangan Selesai Topik</strong> sebagai bukti
            penyelesaian.
          </Text>
        </div>
      )
    }
    if (certificateStatus === CERTIFICATE_STATUS.AVAILABLE) {
      return (
        <div className={clsx('flex gap-3', contentClassName)}>
          <div
            className={
              'flex justify-center flex-shrink-0 items-center w-8 h-8 rounded-full overflow-hidden bg-icon-informational'
            }
          >
            <Icon as="i" fontSize="sm" color="inverse">
              download_outlined
            </Icon>
          </div>
          <div className="w-full">
            <Badge className="mb-2">Sertifikat Tersedia</Badge>
            <Text color="subdued" variant="body-sm" data-testid="card-element">
              Unduh sertifikat Anda karena telah menyelesaikan topik ini.
            </Text>

            <Anchor
              href={`/pelatihan-mandiri/topik/${props.topikId}/sertifikat`}
            >
              <Button
                as="span"
                color="black"
                fullWidth
                size="md"
                className="mt-4"
              >
                Lihat Sertifikat
              </Button>
            </Anchor>
          </div>
        </div>
      )
    }

    return (
      <div className={clsx('flex gap-3', contentClassName)}>
        <div
          className={
            'flex justify-center flex-shrink-0 items-center w-8 h-8 rounded-full overflow-hidden bg-icon-disabled'
          }
        >
          <Icon as="i" fontSize="sm" color="inverse">
            download_outlined
          </Icon>
        </div>
        <div className="w-full">
          <Badge className="mb-2">Sertifikat dalam proses</Badge>
          <Text color="subdued" variant="body-sm" data-testid="card-element">
            Begitu selesai diproses, sertifikat Anda akan muncul di sini.
          </Text>
        </div>
      </div>
    )
  }
  return (
    <div
      className={clsx(
        isDesktop ? 'rounded-lg border border-gray-20 p-4' : 'px-3 my-5'
      )}
    >
      {showHeader && (
        <Text variant={isDesktop ? 'heading-sm' : 'heading-md'}>
          Sertifikat
        </Text>
      )}

      {renderContent(props.certificateStatus)}
    </div>
  )
}

export default CertificateAksiNyataCard
